import { ChannelIcon } from '../../../components/ui/ChannelIcon';
import type { FormatBucket } from '../../../lib/reporting/socialContent';

// Content tab — Performance by format (feed vs reel, by platform). Avg engagement
// + avg views per bucket, so "which format lands?" reads at a glance. FB/IG only
// (GBP has no post analytics). Stories excluded (deferred).
const FORMAT_LABEL: Record<FormatBucket['format'], string> = { feed: 'Feed', reel: 'Reel' };

export function FormatSection({ buckets }: { buckets: FormatBucket[] }) {
  if (buckets.length === 0) return null;
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
      {buckets.map((b) => (
        <div key={`${b.platform}_${b.format}`} className="rounded-md border border-slate-200 p-3">
          <div className="mb-1.5 flex items-center gap-1.5">
            <ChannelIcon channel={b.platform} className="h-3.5 w-3.5" />
            <span className="text-xs font-medium text-slate-700">{FORMAT_LABEL[b.format]}</span>
            <span className="text-[11px] text-slate-400">· {b.count} {b.count === 1 ? 'post' : 'posts'}</span>
          </div>
          <dl className="space-y-1">
            <Row label="Avg engagement" value={Math.round(b.avgEngagement).toLocaleString()} />
            <Row label="Avg views" value={b.avgViews === null ? '—' : Math.round(b.avgViews).toLocaleString()} />
          </dl>
        </div>
      ))}
    </div>
  );
}

function Row({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex items-baseline justify-between gap-2">
      <dt className="text-[11px] text-slate-400">{label}</dt>
      <dd className="text-sm font-semibold tabular-nums text-slate-900">{value}</dd>
    </div>
  );
}
